import { render, staticRenderFns } from "./ClinicPharmacy.vue?vue&type=template&id=c7d7fce8&scoped=true&"
import script from "./ClinicPharmacy.vue?vue&type=script&lang=js&"
export * from "./ClinicPharmacy.vue?vue&type=script&lang=js&"
import style1 from "./ClinicPharmacy.vue?vue&type=style&index=1&id=c7d7fce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d7fce8",
  null
  
)

export default component.exports